import { render, staticRenderFns } from "./KlantenBase.vue?vue&type=template&id=1bbef7dc&scoped=true&"
import script from "./KlantenBase.vue?vue&type=script&lang=js&"
export * from "./KlantenBase.vue?vue&type=script&lang=js&"
import style0 from "./KlantenBase.vue?vue&type=style&index=0&id=1bbef7dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbef7dc",
  null
  
)

export default component.exports